import { Injectable } from '@angular/core';
import { API_SERVER, API_SERVER_VERSION } from '../../app.constants';
import { Headers, Http, RequestOptions, RequestOptionsArgs, Response, ResponseContentType } from '@angular/http';
import { deserialize, serialize } from 'json-typescript-mapper';
import { Observable } from 'rxjs/Observable';
import {Branch} from '../../entities';

@Injectable()
export class ApiService {

  private resourceUrl = API_SERVER + 'api/' + API_SERVER_VERSION + '/';
  private branches: Branch[];

  constructor(
    private http: Http,
  ) { }

  find<T>(clazz: {new(): T}, apiPath: string, options: RequestOptionsArgs = null,
          regardlessServerVersion: boolean = false): Observable<T[]> {
    const url = (!regardlessServerVersion) ? this.resourceUrl : API_SERVER + 'api/';
    return this.http.get(url + apiPath, options ).map(function(res: Response) {
      const body = res.json();

      const itemsArray: T[] = [];
      body.forEach(function(item) {
        itemsArray.push(deserialize<T>(clazz, item));
      });

      return itemsArray;
    });
  }

  findRegular<T>(clazz: {new(): T}, apiPath: string): Observable<T[]> {
    return this.http.get(this.resourceUrl + apiPath ).map(function(res: Response) {
      const body = res.json();

      const itemsArray: T[] = [];
      body.forEach(function(item) {
        itemsArray.push(item);
      });

      return itemsArray;
    });
  }

  getMarkets<T>(clazz: {new(): T}, apiPath, requestBody: String[]): Observable<T[]> {
    return this.http.post(this.resourceUrl + apiPath, requestBody)
      .map(function(res: Response) {
      const body = res.json();

      const itemsArray: T[] = [];
      body.forEach(function(item) {
        itemsArray.push(deserialize<T>(clazz, item));
      });

      return itemsArray;
    });
  }

  findOne<T>(clazz: {new(): T}, apiPath: string): Observable<T> {
    return this.http.get(this.resourceUrl + apiPath).map(function(res: Response) {
      const body = res.json();
      return deserialize<T>(clazz, body);
    });
  }

  findOneRegular<T>(clazz: {new(): T}, apiPath: string): Observable<T> {
    return this.http.get(this.resourceUrl + apiPath).map(function(res: Response) {
      return res.json() as T;
    });
  }

  findOneRegularNumber( apiPath: string): Observable<number> {
    return this.http.get(this.resourceUrl + apiPath).map(function(res: Response) {
      return res.json() as number;
    });
  }

  get(apiPath): Observable<any> {
    return this.http.get(this.resourceUrl + apiPath);
  }

  getImage(apiPath): Observable<Blob> {
    return this.http.get(this.resourceUrl + apiPath, { responseType: ResponseContentType.Blob })
      .map((res: Response) => res.blob());
  }

  post(entities: any, apiPath: string, regardlessServerVersion: boolean = false): Observable<any> {
    const url = (!regardlessServerVersion) ? this.resourceUrl : API_SERVER + 'api/';
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.post(url + apiPath, JSON.stringify(serialize(entities)), options);
  }

  postRegular(entities: any, apiPath: string): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.post(this.resourceUrl + apiPath, entities, options);
  }

  put(entities: any, apiPath: string, regardlessServerVersion: boolean = false): Observable<any> {
    const url = (!regardlessServerVersion) ? this.resourceUrl : API_SERVER + 'api/';
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.put(url + apiPath, JSON.stringify(serialize(entities)), options);
  }

  putRegular(entities: any, apiPath: string): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.put(this.resourceUrl + apiPath, entities, options);
  }

  delete(apiPath: string, regardlessServerVersion: boolean = false): Observable<any> {
    const url = (!regardlessServerVersion) ? this.resourceUrl : API_SERVER + 'api/';
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.delete(url + apiPath, options);
  }

  async getBranches() {
    if (this.branches) { return this.branches; }
    this.branches = await this.find(Branch, 'branches').toPromise();
    this.branches.sort((a, b) => a.branchNumber > b.branchNumber ? 1 : (a.branchNumber < b.branchNumber ? -1 : 0));
    return this.branches;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/api.service.ts